import { ChannelKind } from '@castoredc/castor_prose';
import { protocolSourceOf } from '@hub/prose-utils';
import { getProtocolEditorService } from 'features/questionnaires/services/proseServiceFactory';
import { EMAIL_CHANNEL, SMS_CHANNEL } from './constants';
import { NOTIFICATION_CHANNELS } from './types';
import type { NotificationChannel } from './types';

export type NotificationTemplateChannels = {
  name: string;
  channels: NotificationChannel[];
};

const CHANNEL_BY_KIND: Partial<Record<ChannelKind, NotificationChannel>> = {
  [ChannelKind.EMAIL]: EMAIL_CHANNEL,
  [ChannelKind.SMS]: SMS_CHANNEL,
};

/**
 * Channels in `NOTIFICATION_CHANNELS` order. Kinds outside the channel union
 * (`UNSPECIFIED`, `UNRECOGNIZED`) are dropped.
 */
function toChannels(kinds: ChannelKind[]): NotificationChannel[] {
  const present = new Set(kinds.map(kind => CHANNEL_BY_KIND[kind]));
  return NOTIFICATION_CHANNELS.filter(channel => present.has(channel));
}

export async function getNotificationTemplatesFromDsl(
  dslSource: string
): Promise<NotificationTemplateChannels[]> {
  const protocolEditorService = await getProtocolEditorService();
  const { templates } = protocolEditorService.get_notification_templates({
    protocolSource: protocolSourceOf(dslSource),
  });
  return templates.map(t => ({
    name: t.name,
    channels: toChannels(t.channels),
  }));
}
